import React from "react";

const AnalysisTabIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5ZM11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5Z"
        fill="#646F87"
      />
      <path
        d="M18.2929 18.2929C18.6834 17.9024 19.3166 17.9024 19.7071 18.2929L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L18.2929 19.7071C17.9024 19.3166 17.9024 18.6834 18.2929 18.2929Z"
        fill="#646F87"
      />
      <path
        d="M10.5 8C10.5 7.44772 10.0523 7 9.5 7C8.94772 7 8.5 7.44772 8.5 8V10.5V12.5V15C8.5 15.5523 8.94772 16 9.5 16C10.0523 16 10.5 15.5523 10.5 15V12.5V10.5V8Z"
        fill="#646F87"
      />
      <path
        d="M14.5 10C14.5 9.44772 14.0523 9 13.5 9C12.9477 9 12.5 9.44772 12.5 10V12.5V15C12.5 15.5523 12.9477 16 13.5 16C14.0523 16 14.5 15.5523 14.5 15V12.5V10Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default AnalysisTabIcon;
